var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "F\\xFCllung",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,480C132.49,480,32,379.52,32,256S132.49,32,256,32,480,132.49,480,256,379.52,480,256,480Zm0-416C150.13,64,64,150.13,64,256s86.13,192,192,192,192-86.13,192-192S361.87,64,256,64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.07,96.27c40.8,0,69.7,27.88,69.7,51.34,0,7.82-4.42,15.64-13.6,15.64-22.1,0-10.54-41.14-58.14-41.14-21.76,0-39.78,10.2-39.78,28.56,0,43.86,120.7,39.1,120.7,112.88,0,22.78-15.64,45.56-37.06,57.46,15,10.2,22.1,23.12,22.1,40.12,0,33.66-37.4,53-71.4,52.7-51.34-.68-76.84-33.32-76.84-49,0-12.24,6.12-17,15-17,22.44,0,12.24,40.12,61.2,40.12,27.2,0,42.16-12.24,42.16-27.2C297.07,317.27,172,321,172,248.59c0-30.26,17.34-45.9,41.48-58.14-15.64-11.56-22.1-21.08-22.1-38.42C191.33,116.67,220.91,96.27,263.07,96.27Zm-19,192.1,38.76,19C307.27,289.05,312,277.49,312,264.57c0-14.28-3.06-26.18-30.26-38.76l-42.5-19.72c-20.06,8.5-37.4,19-37.4,40.12C201.87,263.89,217.17,275.11,244,288.37Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTos);
export default __webpack_public_path__ + "static/media/icon-tos.ce223239.svg";
export { ForwardRef as ReactComponent };